var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSouvenir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 42,
    viewBox: "0 0 44 42",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fill: "#334368",
    fillRule: "evenodd",
    stroke: "none",
    d: "M 3.053101 39.326965 C 3.438354 40.571899 4.860107 40.268921 6.505127 40.269531 C 8.030273 40.269531 9.55481 40.269531 11.079834 40.269531 C 14.00769 40.269531 17.333618 40.14209 20.21106 40.283569 L 20.248901 20.093323 L 3.064819 20.066223 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1",
    fill: "#334368",
    fillRule: "evenodd",
    stroke: "none",
    d: "M 23.064575 40.231079 C 23.931763 40.363831 36.070801 40.263306 38.082275 40.27124 C 40.310059 40.280273 40.04541 39.276855 40.04541 37.566895 C 40.04541 31.740723 40.07251 25.909973 40.044189 20.084412 L 23.068359 20.042542 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2",
    fill: "#334368",
    fillRule: "evenodd",
    stroke: "none",
    d: "M 24.233643 11.589844 C 24.649292 10.397034 26.229004 8.292725 27.001587 7.548157 C 28.250366 6.344604 29.878784 5.14624 31.588379 6.628967 C 34.976807 9.567261 27.300781 11.342346 24.233643 11.589844 Z M 19.121948 11.588257 C 16.066772 11.362 8.382813 9.560547 11.770386 6.628357 C 12.307739 6.162964 13.407593 5.707886 14.437378 6.116821 C 16.207275 6.82019 18.586792 10.078491 19.121948 11.588257 Z M 20.166016 17.63147 L 20.271362 11.871399 C 20.793091 11.734863 22.569946 11.729736 23.0802 11.877502 C 23.365601 13.483826 22.822021 16.128479 23.182983 17.636108 L 41.716553 17.630249 C 41.772461 16.515259 41.728516 15.349548 41.728516 14.253174 C 41.729126 13.033752 41.882446 12.033752 40.505127 11.8797 C 38.21875 11.623657 35.029785 12.049988 32.625 11.839722 C 33.027954 11.401978 36.0979 9.953125 34.990234 6.970764 C 34.399048 5.379028 32.671143 3.861877 30.567383 3.564026 C 27.101563 3.073975 24.58606 6.068848 23.207764 8.032104 C 22.810669 8.597961 22.052612 10.042236 21.679321 10.411133 C 20.891357 9.640747 18.057617 2.9375 12.900513 3.547729 C 9.818726 3.912048 6.922119 7.215515 8.688354 9.942932 C 9.327515 10.930054 9.821533 11.169189 10.733154 11.839111 C 8.341675 12.056396 5.127319 11.62085 2.851685 11.878113 C 1.57605 12.022583 1.622803 13.06134 1.623291 14.156067 C 1.62439 15.288025 1.579834 16.484253 1.63562 17.607788 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSouvenir);
export default __webpack_public_path__ + "static/media/icon-souvenir.40511db0ed284c971bfed1c35af0fc21.svg";
export { ForwardRef as ReactComponent };